module.exports = __webpack_public_path__ + "static/media/dui.388ce22f.svg";